import Vue from 'vue'
import App from './App.vue'
import router from './router'  // 确保这里导入的是 router 实例
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { brand, loadBrandSettings } from '@/utils/brand'
import '@/styles/collection-theme.scss'

Vue.config.productionTip = false

// 只在这里调用一次 Vue.use
Vue.use(ElementUI)
Vue.prototype.$brand = brand
loadBrandSettings()

new Vue({
  router,  // 注入路由实例
  render: h => h(App)
}).$mount('#app')
